import React from 'react';
import GatsbyLink from '../src/components/GatsbyLink';
import './LogoFooter.scss';

export const Logo = props => {
  return (
    <GatsbyLink to="/" className="logo-footer" aria-label="Logo"></GatsbyLink>
  );
}
